const Materialize = window.Materialize

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated materialize n'est plus utilisé, utiliser les composants MUI à la place
 */
const updateMaterialize = () => {
    if (Materialize && Materialize.updateTextFields) {
        Materialize.updateTextFields()
    }
    $('ul.tabs').tabs()
    $('.modal').modal()
}

export { updateMaterialize }

